import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    Input,
    OnInit,
    Type,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { ColumnComponent, FilterService as KendoFilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { FilterService } from '../../services/filter.service';
import { Column } from '../../classes/column';

@Component({
    selector: 'chassis-datatable-filter',
    templateUrl: './filter.component.html',
})
export class FilterComponent implements OnInit {

    /**
     * The filter component.
     */
    @Input() component: ColumnComponent;

    /**
     * The filter instance.
     */
    @Input() filter: FilterDescriptor | CompositeFilterDescriptor;

    /**
     * The data table column.
     */
    @Input() column: Column;

    @Input() filterMode: 'menu' | 'row' = 'menu';

    @Input() kendoFilterService: KendoFilterService;

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected filterService: FilterService,
    ) {
        //
    }

    public ngOnInit(): void {
        // Cancel when no filter is needed.
        if (!this.column.filter) {
            return;
        }

        const component = this.getFilterComponent();

        // Cancel when no filter component is registered.
        if (!component) {
            return;
        }
        const componentFactory: ComponentFactory<any> = this.createFilterComponentFactory(
            component
        );

        const componentRef: ComponentRef<any> = this.createFilterComponentRef(
            componentFactory,
        );

        const instance = componentRef.instance;

        this.bindProperties(instance);
    }

    protected getFilterComponent(): Type<any> | null {
        return this.filterService.get(
            <string>this.column.filter,
            this.filterMode
        );
    }

    protected createFilterComponentFactory(component: Type<any>): ComponentFactory<any> {
        return this.componentFactoryResolver.resolveComponentFactory(
            component,
        )
    }

    protected createFilterComponentRef(factory: ComponentFactory<any>): ComponentRef<any> {
        return this.content.createComponent(
            factory,
        )
    }

    protected bindProperties(instance: Component): void {
        instance['filter']        = this.filter;
        instance['column']        = this.component;
        instance['options']       = this.column;
        instance['filterService'] = this.kendoFilterService;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filter/filter.component.ts